<template>
    <div>
        <NavTop/>
        <NavDark/>

        <div class="gray py-3 mt-3">
            <div class="container">
                <div class="row">
                    <div class="colxl-12 col-lg-12 col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="/">Velkommen</router-link></li>
                                <li class="breadcrumb-item active" aria-current="page">Om</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>




        <section class="middle">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">

                        <div class="sec_title position-relative text-center">
                            <div class="sec_title position-relative text-center" data-bgtext="Om YOKO">
                                <h1 class="ft-bold pt-3">Om YOKO</h1>
                            </div>
                        </div>

                        <div class="abt_caption">
                   
                            <p class="mb-4">Yoko.dk er Danmarks største og mest dedikerede markedsplads for kunsthåndværk af høj kvalitet. Her samler vi passionerede kunstnere, designere og kreative sjæle, der brænder for at skabe unikke produkter, du ikke finder andre steder. Uanset om du søger et særligt smykke, <a href="/shop/keramik" title="Køb keramik til hjemmet" class="">keramik til hjemmet</a>, <a href="/shop/billedkunst" title="Køb billedkunst online" class="">billedkunst</a> eller <a href="/kunstnere/tekstil" title="Danske tekstildesignere" class="">tekstiler</a> med historie, er Yoko.dk stedet, hvor håndværk møder hjerte.</p>
                            
                            <h2>Største platform for kunsthåndværk</h2>

                            <p class="mb-4">Yoko.dk er Danmarks største markedsplads for kunst og kunsthåndværk online. Her finder du alt fra håndlavet keramik og smykker til billedkunst og tekstiler – alt sammen skabt af passionerede kunstnere og kreative iværksættere fra hele landet. Hos os køber du ikke masseproducerede varer, men unikke værker, der bærer en personlig historie.</p>

<h2>Køb kunsthåndværk online i Danmark</h2>

<p class="mb-4">Når du shopper på Yoko.dk, træder du ind i et univers af ægte dansk kunsthåndværk. Vi gør det nemt at finde særlige produkter, du ikke ser i de traditionelle butikker. Vores markedsplads samler hundredevis af kreative sjæle, så du kan gå på opdagelse i et af Danmarks bredeste udvalg af håndlavede produkter.</p>

<p class="mb-4">Uanset om du leder efter et håndlavet smykke, et smukt stykke keramik til hjemmet, billedkunst eller et tekstildesign, finder du det her. Ved at handle på Yoko.dk støtter du direkte den kunstner, der har skabt værket – og du får noget helt særligt med hjem.</p>

<h2>Kvalitets-kunsthåndværk til salg</h2>

<p class="mb-4">På Yoko.dk kan du være sikker på, at alt er lavet med omtanke og kærlighed til håndværket. Vi er dedikerede til at give kunstnere en platform, hvor de kan vise deres arbejde frem og nå et større publikum. For dig som kunde betyder det, at du kan købe unikke håndlavede gaver, boligtilbehør og kunstværker med sjæl.</p>
<ul>
<li><b>- Danmarks største udvalg af kunsthåndværk samlet ét sted.</b></li>

    <li><b>- Direkte kontakt med kunstneren bag produktet.</b></li>

        <li><b>- Ægte håndværk – aldrig masseproduktion.</b></li>
</ul><br />
<h2>Sælg dit kunsthåndværk online</h2>

<p class="mb-4">Er du kunstner, designer eller kreativ iværksætter? På Yoko.dk kan du nemt oprette din egen webshop og få dine produkter vist frem på Danmarks største platform for kunsthåndværk. Vi giver dig værktøjerne til at sælge online og samtidig nå ud til kunder, der aktivt søger unikke, håndlavede produkter.</p>

<h2>Unikke håndlavede gaver til hjemmet</h2>

<p class="mb-4">Hvis du leder efter en gave, der skiller sig ud, eller noget særligt til dit hjem, så er Yoko.dk det oplagte sted at starte. Her finder du gaver med historie, håndlavet kunsthåndværk og dansk design, som ikke kan kopieres.</p>

<b>Yoko.dk – din markedsplads for kunsthåndværk af høj kvalitet. Køb og sælg unikt dansk kunsthåndværk online.</b>
                            
                            
                            
                            <!--<div class="form-group mt-4">
                                <router-link to="#" class="btn btn-dark">See More Info</router-link>
                            </div>-->
                        </div>
                    </div>
                    
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                     
                        <div class="sec_title position-relative text-center">
                            <div class="sec_title position-relative text-center" data-bgtext="Historien bag">
                                <h1 class="ft-bold pt-3">Historien bag</h1>
                            </div>
                        </div>

                        <div class="abt_caption">
                        
                            <p class="mb-4">
                               

Yoko.dk er født ud af Shup.dk, den danske platform hvor hundredevis af kunsthåndværkere i dag driver deres egne webshops og sælger unikke produkter online. Shup.dk har siden starten været et hjemsted for kreative iværksættere, der brænder for at dele deres kunst, design og håndlavede værker med verden.
</p>
<p class="mb-4">
Undervejs opstod idéen om at samle de dygtigste webshop-ejere fra Shup i ét fælles univers. Ved at udvælge de mest passionerede kunstnere og designere skabte vi <a href="https://yoko.dk" title="YOKO - Dansk kunsthåndværk webshop">Yoko.dk</a> – en fælles webshop og markedsplads, hvor de individuelle kræfter står stærkere sammen. Formålet er at gøre det lettere for kunder at opdage det bedste danske kunsthåndværk ét sted, og samtidig hjælpe kunstnerne med at nå bredere ud, uden at miste deres individuelle identitet.
</p>
<h2>Yoko Ono</h2>
<p class="mb-4">
   
Navnet YOKO er valgt med omhu. Det er en hyldest til multikunstneren Yoko Ono, som symboliserer kreativitet, mod og grænseløs udfoldelse. For os repræsenterer Yoko.dk netop det samme: et sted hvor <b>kunst</b>, <b>håndværk</b> og fællesskab går hånd i hånd – og hvor hjertet altid er i centrum.<br />Skulle der være nogen der ikke ved det, var Yoko Ono gift med <a href="https://www.youtube.com/watch?v=iOs9Osz3UFQ" target="_blank" title="Yoko Onos mand John Lennon - Sang for fællesskab og frihed - Imagine">John Lennon</a>.
</p>
<p class="mb-4">
Hos Yoko.dk finder du derfor ikke masseproduktion, men <b>keramik</b>, <b>smykker</b>, <b>billedkunst</b> og <b>brugskunst</b>, der hver især bærer en historie. Når du handler her, støtter du både den enkelte kunstner og det stærke fællesskab bag platformen.
</p>
<p class="mb-4">
Yoko.dk er kort sagt resultatet af visionen bag Shup.dk – men i en ny form, hvor de dygtigste kunsthåndværkere får en ekstra mulighed for at skinne, og hvor kunderne kan opleve <b>Danmarks mest inspirerende markedsplads for kunsthåndværk</b>.

                            </p>
                           <div class="form-group mt-4">
                                <router-link to="https://shup.dk" class="btn btn-dark">Se mere om SHUP og opret webshop</router-link>
                            </div>
                            <br /><br />
                        </div>


                        <!--<div class="abt_caption">
                            <img :src="about1" class="img-fluid rounded border" alt="" />
                        </div>-->


                        <div class="abt_caption">
                            <img :src="about2" class="img-fluid rounded border" alt="" />
                        </div>

                    </div>
                </div>
            </div>
        </section>



        <FooterTopTwo/>
        <FooterDark/>
        <ScrollToTop/>

    </div>
</template>

<script setup>
    //import about1 from '@/assets/img/about-1.png'
    import about2 from '@/assets/img/about-2.png'
    
    import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTopTwo from '@/components/footer/footer-top-one.vue';

    import NavDark from '@/components/navbar/nav-dark.vue';
    import NavTop from '@/components/navbar/nav-top.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
</script>